export { escapeHtml } from '../../utils.js';

export function truncate(value, max = 120) {
  const text = String(value || '').trim();
  return text.length <= max ? text : `${text.slice(0, max - 1)}...`;
}

export function stripDataUrlPrefix(value = '') {
  const text = String(value || '');
  const idx = text.indexOf('base64,');
  return idx >= 0 ? text.slice(idx + 'base64,'.length) : text;
}

export function asArray(value) {
  if (Array.isArray(value)) return value;
  if (typeof value === 'string' && value.trim().startsWith('[')) {
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
  return [];
}
